import { useMutation } from '@tanstack/react-query';

import type { LocationFormResponse } from '@/types/api/mutations';

import { HttpClient } from '@/network/HttpClient';

export const useChangeLocationMutation = () =>
  useMutation({
    mutationFn: (params: { url: string; locationId: number }) =>
      HttpClient.request<{ status: string }>({
        method: 'POST',
        url: params.url,
        data: {
          user_session: {
            current_location_id: params.locationId,
          },
        },
      }),
  });

export const useLocationFormMutation = () =>
  useMutation({
    mutationFn: (params: {
      url: string;
      method: 'POST' | 'PUT';
      data: FormData;
    }) =>
      HttpClient.request<LocationFormResponse>({
        method: params.method,
        url: params.url,
        data: params.data,
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }),
  });
